import { PrefillSurveyFieldsInfo } from '../../models/survey';
import { CheckoutState } from '../../state';
import {
    getEmailToPrefill,
    getFirstNameToPrefill,
    getLastNameToPrefill,
} from '../../utils/user';
import { getIsTransferredOrder } from '../order';
import { shouldManageUserSavedSurveyData } from '../order/typedOrderSelectors';
import { getSurveyResponseNameValues } from './getSurveyResponseNameValues';
import { getFirstAttendeeWithSurvey } from './pureSelectors';
import { shouldPrefillFirstAttendeeBasicInfoQuestions } from './shouldPrefillFirstAttendeeBasicInfoQuestions';

export const getPrefillSurveyInfo = (
    state: CheckoutState,
): PrefillSurveyFieldsInfo => ({
    attendeeWithSurvey: getFirstAttendeeWithSurvey(state),
    emailToPrefill: getEmailToPrefill(state),
    firstNameToPrefill: getFirstNameToPrefill(state),
    isTransferredOrder: getIsTransferredOrder(state),
    lastNameToPrefill: getLastNameToPrefill(state),
    shouldManageUserSavedSurveyData: shouldManageUserSavedSurveyData(state),
    shouldPrefillFirstAttendeeBasicInfoQuestions:
        shouldPrefillFirstAttendeeBasicInfoQuestions(state),
    surveyResponseNameValues: getSurveyResponseNameValues(state),
});
